import CryptoJS from 'crypto-js';

const encryptKey = '123THAIGL0033221';

export const encryptData = (data) => {
    const encrypted = CryptoJS.AES.encrypt(data, encryptKey).toString();
    return encodeURIComponent(encrypted);
};

export const decryptData = (encryptedData) => {
    const decodedData = decodeURIComponent(encryptedData);
    const bytes = CryptoJS.AES.decrypt(decodedData, encryptKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
};